<template>
  <Navbar />
  <v-app>
    <div id="content">
      <v-container class="py-8" fluid max-width="1200">
        <v-row justify="center" align="start" class="mb-8 mt-5">
          <!-- Left Column: Shipping Address Form -->
          <v-col cols="12" md="8">
            <v-card class="pa-4" outlined>
              <v-card-title class="text-h6">Add New Shipping Address</v-card-title>
              <v-card-text>
                <v-form ref="addressForm" lazy-validation>
                  <v-row>
                    <!-- Full Name -->
                    <v-col cols="12" sm="4">
                      <v-text-field label="Full name" placeholder="Enter your full name" v-model="form.fullName"
                        :rules="[rules.required]" />
                    </v-col>

                    <!-- Phone Number -->
                    <v-col cols="12" sm="4">
                      <!-- <v-text-field label="Phone Number" placeholder="Please enter your phone number"
                        v-model="form.phone" :rules="[rules.required]" /> -->
                      <v-text-field label="Phone Number" placeholder="Please enter your phone number"
                        v-model="form.phone" :rules="[rules.required, rules.number, ]"  type="tel" />

                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field label="Email" placeholder="Enter your email" v-model="form.email"
                        :rules="[rules.required, rules.email]" />
                    </v-col>
                    <!-- Province -->
                    <v-col cols="12" sm="6">
                      <!-- <v-select label="Province" :items="formattedProvinces" v-model="form.province"
                        :rules="[rules.required]" item-text="name" item-value="id" placeholder="Select Province"
                        @change="fetchMunicipalities" /> -->
                      <v-select label="Province" v-model="form.province" :items="provinces" :rules="[rules.required]"
                        item-title="name" item-value="id" placeholder="Select Province"
                        @update:modelValue="onProvinceChange" />
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-select label="District" v-model="form.district" :items="districts" :rules="[rules.required]"
                        item-title="name" item-value="id" placeholder="Select District"
                        @update:modelValue="onDistrictChange" />
                    </v-col>

                    <!-- Municipality -->
                    <v-col cols="12" sm="4">
                      <v-select label="Municipalities" :items="municipalities" v-model="form.municipality"
                        :rules="[rules.required]" item-title="name" item-value="id"
                        placeholder="Select municipalities" />
                    </v-col>

                    <!-- Ward -->
                    <v-col cols="12" sm="4">
                      <!-- <v-text-field label="Ward" :items="wards" v-model="form.ward" :rules="[rules.required]"
                        item-text="name" item-value="id" placeholder="Enter your Ward" /> -->
                      <v-text-field label="Ward" placeholder="Enter your Ward" v-model="form.ward"
                        :rules="[rules.required, rules.number]"  />

                    </v-col>

                    <!-- Street -->
                    <v-col cols="12" sm="4">
                      <v-text-field label="Street" placeholder="Enter your street" v-model="form.street"
                        :rules="[rules.required]" />
                    </v-col>

                    <!-- Note -->
                    <v-col cols="12">
                      <v-textarea label="Note" placeholder="Enter any additional notes (optional)"
                        v-model="form.note" />
                    </v-col>
                  </v-row>
                  <!-- 
                  <div class="d-flex justify-end mt-4">
                    <v-btn color="grey" class="mr-2" @click="cancelForm">CANCEL</v-btn>
                    <v-btn color="primary" :disabled="!valid" @click="saveForm">SAVE</v-btn>
                  </div> -->
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Right Column: Order Summary -->
          <v-col cols="12" md="4">
            <OrderSummary :cart-items="cartStore.cart" :grand-total="grandTotal" :tax-amount="taxAmount"
              :total-with-tax="totalWithTax" :loading="loading" :disabled="!isValid"
              :proceed-to-checkout="proceedToPayment" btn-text="Proceed to Pay" />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- fsadf {{ province }} -->
    <!-- {{ formattedProvinces }} -->
  </v-app>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import Navbar from "../components/Navbar.vue";
import { useRouter } from "vue-router";
import { useCartStore } from "@/Store/cartStore";
import OrderSummary from "../components/SharedUI/OrderSummary.vue";
import { addressProvinces } from "@/services/apiServices.js";
import axios from "axios";
import { apiConfig } from "@/config/apiConfig";
const router = useRouter();
const cartStore = useCartStore();
const grandTotal = cartStore.grandTotal;
const taxAmount = cartStore.taxAmount;
const totalWithTax = cartStore.totalWithTax;
const loading = ref(false);
const error = ref("");
const addressForm = ref(null);
const isValid = ref(false);

const form = ref({
  fullName: "",
  phone: "",
  email: "",
  province: "",
  district: "",
  municipality: "",
  ward: "",
  street: "",
  note: "",
});

const provinces = ref([]);

// "province_1".split('_')
// => ["province", "1"]

// ["province", "1"].map(word => word.charAt(0).toUpperCase() + word.slice(1))
// => ["Province", "1"]

// ["Province", "1"].join(' ')
// => "Province 1"

const districts = ref([]);

const municipalities = ref([]);
// const wards = ref([]);

const rules = {
  required: (v) => !!v || "This field is required",

  // Phone must be numeric and at least 7 digits
  phone: (v) =>
    !!v && /^\d{7,}$/.test(v) || "Phone number must be at least 7 digits and numeric",

  // Ward must be numeric and at least 1 digit
  ward: (v) =>
    !!v && /^\d+$/.test(v) || "Ward must be a numeric value",

     // Email must follow proper email format
  email: (v) =>
    !!v && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Please enter a valid email address",
};


const fetchProvince = async () => {
  try {
    const data = await addressProvinces();
    provinces.value = data.map((id) => ({
      id: id,
      name: id
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
    }));
    // console.log("Provinces:", provinces.value);
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to load provinces";
    console.error("Error fetching provinces:", err);
  }
};

onMounted(fetchProvince);

const fetchDistricts = async () => {
  try {
    // console.log("fetchDistricts called", form.value.province);
    if (form.value.province) {
      const res = await axios.get(
        `${apiConfig.baseUrl}/address/?province=${form.value.province}`
      );
      // console.log("Districts response:", res);

      // Map and format district names
      districts.value = res.data.map((id) => ({
        id: id,
        name: id
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      }));

      // console.log("Districts:", districts.value);
    }
  } catch (err) {
    console.error("Error fetching districts:", err);
  }
};

const fetchMunicipalities = async () => {
  try {
    // console.log("fetchMunicipalities called", form.value.municipality);
    if (form.value.province && form.value.district) {
      const res = await axios.get(
        `${apiConfig.baseUrl}/address/?province=${form.value.province}&district=${form.value.district}`
      );
      municipalities.value = res.data.map((id) => ({
        id: id,
        name: id
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      }));
    }
  } catch (err) {
    console.error("Error fetching districts:", err);
  }
};

const onProvinceChange = () => {
  // console.log("Province changed:", form.value.province);
  form.value.district = null;
  districts.value = [];
  fetchDistricts();
};

const onDistrictChange = () => {
  // console.log("District changed:", form.value.district);
  form.value.municipality = null;
  municipalities.value = [];
  fetchMunicipalities();
};



// const cancelForm = () => {
//   addressForm.value.reset();
// };

// const saveForm = () => {
//   if (addressForm.value.validate()) {
//     console.log("Submitted form:", form.value);
//   }
// };

// const proceedToPayment = () => {
//   if (addressForm.value.validate()) {

//     localStorage.setItem('shippingAddress', JSON.stringify(form.value))
//     router.push('/payment')
//   }
// }

const proceedToPayment = async () => {
  const result = await addressForm.value.validate();

  // console.log("Validation result:", result);

  if (result.valid) {
    localStorage.setItem('shippingAddress', JSON.stringify(form.value));
    router.push('/payment');
  } else {
    console.warn("Form validation failed. Fill all required fields.");
  }
};
onMounted(() => {
  const savedAddress = localStorage.getItem('shippingAddress');
  if (savedAddress) {
    form.value = JSON.parse(savedAddress); // Load saved data into form
  }
});

</script>
